<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                </el-button-group>
                <div class="mg-right5 mg-top5">
                    <el-checkbox v-model="search.up_flag" true-label="1" false-label="0" @change="list()">仅显示已上架商品</el-checkbox>
                </div>
            </div>
            <div class="fillw fillh">
                <div class="tree-box fillh" style="overflow-y: auto">
                    <div v-if="cats.length > 0">
                        <div v-for="item in cats" :key="item.cat_id">
                            <div class="flex-box pd-5">
                                <Icon class="f-back mg-right5" type="logo-buffer" />{{item.cat_cname}}
                            </div>
                            <div class="sub-tree pd-5 c1" v-for="item2 in item.children" :key="item2.cat_id2">
                                <div class="flex-box pd-5">
                                    <Icon class="f-back mg-right5" type="logo-buffer" />{{item2.cat_cname}}
                                </div>
                                <div class="sub-tree c2 border-bottom-line" v-for="item3 in item2.goods" :key="item3.goods_id">
                                    <div class="flex-box nopadding">
                                        <div class="width-60">
                                            <myImgshow :src="item3.img_lnk" @onClick="$base.alertImg(item3.img_lnk, item3.goods_cname)"></myImgshow>
                                        </div>
                                        <div class="mg-left10 flex-box-bd tleft">
                                            <div class="mg-bottom10 flex-box nopadding">
                                                <div class="f-bd width-100 tleft">ID:{{item3.goods_id}}</div>
                                                <el-tag size="mini" :class="item3.org_goods_id != '' && item3.org_goods_status == '1'?'bg-green':'bg-gray'">
                                                    {{item3.org_goods_status_cdesc || '未配置'}}
                                                </el-tag>
                                                <div class="mg-left5 f-bd">{{item3.goods_cname}}</div>
                                            </div>
                                            <div class="f13 f-brown f-bd" v-if="item3.org_goods_id != ''">
                                                已绑定供应商：{{item3.vendor_cname}}(产品ID：{{item3.mac_goods_id}}，结算价：{{item3.cost_amt * 1}}元)
                                            </div>
                                            <div class="f13 f-gray" v-else>
                                                尚未绑定供应商
                                            </div>
                                        </div>
                                        <a class="link" @click="openSave(item3)">{{item3.org_goods_id == ''?'配置':'详情'}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <myNodata></myNodata>
                    </div>
                </div>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
    import myNodata from '../../../components/myNodata'
    import myImgshow from '../../../components/myImgshow'
    export default {
        name:"org-role",
        components:{
            myNodata,
            myImgshow
        },
        data:function(){
            return{
                show_subview:false,
                relist:false,
                search:{
                    search_url:'org-goods/list',
                    up_flag:'1'
                },
                cats: []
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.list();
        },
        methods:{
            list: function () {
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            openSave:function (item) {
                if(item.org_goods_id != ''){
                    this.$base.linkTo("/base/orggoods/save",{org_goods_id:item.org_goods_id});
                }
                else{
                    this.$base.linkTo("/base/orggoods/save",{goods_id:item.goods_id});
                }
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(true);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>
    .tree-box{
        max-width: 800px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/base/orggoods/list.vue